//
//
//

import G2 from '@antv/g2';

export default {
  name: 'gaugechart',
  props: ['chartData', 'chartId'],
  data() {
    return {
      data: [],
      id: '',
      gaugechart: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      this.barchart.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    let that = this;
    var Shape = G2.Shape;
    // 自定义Shape 部分
    Shape.registerShape('point', 'pointer', {
      drawShape: function drawShape(cfg, group) {
        var center = this.parsePoint({
          // 获取极坐标系下画布中心点
          x: 0,
          y: 0
        });
        // 绘制指针
        group.addShape('line', {
          attrs: {
            x1: center.x,
            y1: center.y,
            x2: cfg.x,
            y2: cfg.y,
            stroke: cfg.color,
            lineWidth: 5,
            lineCap: 'round'
          }
        });
        return group.addShape('circle', {
          attrs: {
            x: center.x,
            y: center.y,
            r: 9.75,
            stroke: cfg.color,
            lineWidth: 4.5,
            fill: '#fff'
          }
        });
      }
    });

    var color = ['#0086FA', '#FFBF00', '#F5222D'];
    that.gaugechart = new G2.Chart({
      container: that.id,
      forceFit: true,
      height: document.querySelector('#' + this.id + '').clientHeight,
      width: document.querySelector('#' + this.id + '').clientWidth,
      padding: [0, 0, 30, 0],
      animate: false
    });
    that.gaugechart.source(that.data.value);

    that.gaugechart.coord('polar', {
      startAngle: (-9 / 8) * Math.PI,
      endAngle: (1 / 8) * Math.PI,
      radius: 0.75
    });
    let tickInterval = 1;
    if (that.data.end - that.data.start >= 50) {
      tickInterval = 10;
    } else if (that.data.end - that.data.start > 10) {
      tickInterval = 5;
    }
    that.gaugechart.scale('value', {
      min: that.data.start,
      max: that.data.end,
      tickInterval: tickInterval,
      nice: false
    });

    that.gaugechart.axis('1', false);
    that.gaugechart.axis('value', {
      zIndex: 2,
      line: null,
      label: {
        offset: -20,
        textStyle: {
          fontSize: 18,
          fill: '#CBCBCB',
          textAlign: 'center',
          textBaseline: 'middle'
        }
      },
      tickLine: {
        length: -24,
        stroke: '#fff',
        strokeOpacity: 1
      },
      grid: null
    });
    that.gaugechart.legend(false);
    var precent = (that.data.end - that.data.start) / 6;
    that.gaugechart
      .point()
      .position('value*1')
      .shape('pointer')
      .color('value', function(val) {
        if (val < 2 * precent) {
          return color[0];
        } else if (val <= 4 * precent) {
          return color[1];
        } else if (val <= 6 * precent) {
          return color[2];
        }
      })
      .active(false);

    draw(that.data.value.value);

    function draw(data) {
      // console.log(data);
      var val = data;
      var lineWidth = 25;
      that.gaugechart.guide().clear();
      // 绘制仪表盘背景
      that.gaugechart.guide().arc({
        zIndex: 0,
        top: false,
        start: [0, 0.92],
        end: [that.data.end, 0.92],
        style: {
          // 底灰色
          stroke: '#CBCBCB',
          lineWidth: lineWidth
        }
      });
      val >= 2 * precent &&
        that.gaugechart.guide().arc({
          zIndex: 1,
          start: [0, 0.92],
          end: [val, 0.92],
          style: {
            stroke: color[0],
            lineWidth: lineWidth
          }
        });

      val >= 4 * precent &&
        that.gaugechart.guide().arc({
          zIndex: 1,
          start: [2 * precent, 0.92],
          end: [4 * precent, 0.92],
          style: {
            stroke: color[1],
            lineWidth: lineWidth
          }
        });

      val > 4 * precent &&
        val <= 6 * precent &&
        that.gaugechart.guide().arc({
          zIndex: 1,
          start: [4 * precent, 0.92],
          end: [val, 0.92],
          style: {
            stroke: color[2],
            lineWidth: lineWidth
          }
        });

      val > 2 * precent &&
        val <= 4 * precent &&
        that.gaugechart.guide().arc({
          zIndex: 1,
          start: [2 * precent, 0.92],
          end: [val, 0.92],
          style: {
            stroke: color[1],
            lineWidth: lineWidth
          }
        });

      val < 2 * precent &&
        that.gaugechart.guide().arc({
          zIndex: 1,
          start: [0, 0.92],
          end: [val, 0.92],
          style: {
            stroke: color[0],
            lineWidth: lineWidth
          }
        });
      let result = parseInt((val / (that.data.end - that.data.start)) * 100);
      // 绘制指标数字
      that.gaugechart.guide().html({
        position: ['50%', '95%'],
        html:
          '<div style="width: 100%;text-align: center;">' +
          '<p style="color: #545454;font-size: 20px;">' +
          that.data.name +
          '</p>' +
          '<p style="color: #545454;font-size: 20px">' +
          result +
          '%</p>' +
          '</div>'
      });
      that.gaugechart.changeData([{ value: data }]);
    }
  }
};
